/**
 * StingBase
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export type RoofTypeEnum = 1 | 2 | 3 | 4 | 5 | 6 | 7;

export const RoofTypeEnum = {
    NUMBER_1: 1 as RoofTypeEnum,
    NUMBER_2: 2 as RoofTypeEnum,
    NUMBER_3: 3 as RoofTypeEnum,
    NUMBER_4: 4 as RoofTypeEnum,
    NUMBER_5: 5 as RoofTypeEnum,
    NUMBER_6: 6 as RoofTypeEnum,
    NUMBER_7: 7 as RoofTypeEnum
};

